import { delay, put, takeEvery } from 'redux-saga/effects';
import { ADD_BANNER, removeBanner } from './Banners.reducer';

export function* doHandleAddBanner({
  data: {
    options: { timeout },
    id,
  },
}) {
  if (timeout > 0) {
    yield delay(timeout);
    yield put(removeBanner(id));
  }
}

export function* watchBannerSagas() {
  yield takeEvery(ADD_BANNER, doHandleAddBanner);
}
